export interface AffiliateSettings {
  projectName?: string;
  amazonTag: string;
  magaluPartnerId: string;
  mercadolivreTag: string;
  mercadolivreAppId: string;
  mercadolivreSecretKey: string;
  mercadolivreAccessToken: string;
  shopeeAppId: string;
  shopeeSecret: string;
  publicTitle?: string;
  slogan?: string;
  logoUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  metaPixelId?: string;
  ga4MeasurementId?: string;
  privacyPolicyUrl?: string;
  showcaseExpiryWarningDays?: number;
  tenantSlug?: string;
  defaultLinkType?: 'api' | 'marketplace';
}

export const AFFILIATE_SETTINGS_KEY = 'tf_affiliate_settings';

export const DEFAULT_AFFILIATE_SETTINGS: AffiliateSettings = {
  projectName: 'Achadinhos Tech',
  amazonTag: 'affiliator-20',
  magaluPartnerId: 'affiliator',
  mercadolivreTag: 'affiliator',
  mercadolivreAppId: '',
  mercadolivreSecretKey: '',
  mercadolivreAccessToken: '',
  shopeeAppId: '',
  shopeeSecret: '',
  publicTitle: 'Achadinhos Tech',
  slogan: 'As melhores ofertas e promoções da internet em tempo real.',
  logoUrl: '',
  primaryColor: '#2563EB',
  secondaryColor: '#10B981',
  metaPixelId: '',
  ga4MeasurementId: '',
  privacyPolicyUrl: '',
  showcaseExpiryWarningDays: 2,
  defaultLinkType: 'api',
};

export function getAffiliateSettings(): AffiliateSettings {
  try {
    if (typeof localStorage === 'undefined') return DEFAULT_AFFILIATE_SETTINGS;
    const raw = localStorage.getItem(AFFILIATE_SETTINGS_KEY);
    if (!raw) return DEFAULT_AFFILIATE_SETTINGS;
    const parsed = JSON.parse(raw);
    return {
      projectName: parsed.projectName ?? DEFAULT_AFFILIATE_SETTINGS.projectName,
      amazonTag: parsed.amazonTag ?? DEFAULT_AFFILIATE_SETTINGS.amazonTag,
      magaluPartnerId:
        parsed.magaluPartnerId ?? DEFAULT_AFFILIATE_SETTINGS.magaluPartnerId,
      mercadolivreTag:
        parsed.mercadolivreTag ?? DEFAULT_AFFILIATE_SETTINGS.mercadolivreTag,
      mercadolivreAppId:
        parsed.mercadolivreAppId ??
        DEFAULT_AFFILIATE_SETTINGS.mercadolivreAppId,
      mercadolivreSecretKey:
        parsed.mercadolivreSecretKey ??
        DEFAULT_AFFILIATE_SETTINGS.mercadolivreSecretKey,
      mercadolivreAccessToken:
        parsed.mercadolivreAccessToken ??
        DEFAULT_AFFILIATE_SETTINGS.mercadolivreAccessToken,
      shopeeAppId: parsed.shopeeAppId ?? DEFAULT_AFFILIATE_SETTINGS.shopeeAppId,
      shopeeSecret:
        parsed.shopeeSecret ?? DEFAULT_AFFILIATE_SETTINGS.shopeeSecret,
      publicTitle: parsed.publicTitle ?? DEFAULT_AFFILIATE_SETTINGS.publicTitle,
      slogan: parsed.slogan ?? DEFAULT_AFFILIATE_SETTINGS.slogan,
      logoUrl: parsed.logoUrl ?? DEFAULT_AFFILIATE_SETTINGS.logoUrl,
      primaryColor:
        parsed.primaryColor ?? DEFAULT_AFFILIATE_SETTINGS.primaryColor,
      secondaryColor:
        parsed.secondaryColor ?? DEFAULT_AFFILIATE_SETTINGS.secondaryColor,
      metaPixelId: parsed.metaPixelId ?? DEFAULT_AFFILIATE_SETTINGS.metaPixelId,
      ga4MeasurementId:
        parsed.ga4MeasurementId ?? DEFAULT_AFFILIATE_SETTINGS.ga4MeasurementId,
      privacyPolicyUrl:
        parsed.privacyPolicyUrl ?? DEFAULT_AFFILIATE_SETTINGS.privacyPolicyUrl,
      showcaseExpiryWarningDays:
        parsed.showcaseExpiryWarningDays ??
        DEFAULT_AFFILIATE_SETTINGS.showcaseExpiryWarningDays,
      tenantSlug: parsed.tenantSlug,
      defaultLinkType:
        parsed.defaultLinkType ?? DEFAULT_AFFILIATE_SETTINGS.defaultLinkType,
    };
  } catch {
    return DEFAULT_AFFILIATE_SETTINGS;
  }
}

export function saveAffiliateSettings(settings: AffiliateSettings): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(AFFILIATE_SETTINGS_KEY, JSON.stringify(settings));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('affiliate-settings-updated'));
    }
  } catch {
    // Falha silenciosa ou quota excedida
  }
}

export function isMarketplaceConfigured(
  marketplace: string,
  settings: AffiliateSettings = getAffiliateSettings()
): boolean {
  switch (marketplace.toLowerCase()) {
    case 'amazon':
      return Boolean(settings.amazonTag && settings.amazonTag.trim());
    case 'magalu':
      return Boolean(
        settings.magaluPartnerId && settings.magaluPartnerId.trim()
      );
    case 'mercadolivre':
      return Boolean(
        settings.mercadolivreTag && settings.mercadolivreTag.trim()
      );
    case 'shopee':
      return Boolean(
        settings.shopeeAppId &&
        settings.shopeeAppId.trim() &&
        settings.shopeeSecret &&
        settings.shopeeSecret.trim()
      );
    default:
      return true; // Lojas genéricas ou 'other'
  }
}
